import VueCookies from 'vue-cookies'

import { LocationService } from "@/services/nextshop/location.service";

import getListInventory from "@/mixins/inventory/getListInventory"

export default {
  mixins: [getListInventory],

  methods: {
    inforLocation(listLocation, listInventory) {
      let dataLocation = []
      listLocation.map(location => {
        if(location.hasPlanConfig){
          const item = {
            ...location,
            inventories: listInventory.filter(inventory => 
              inventory.coLocationId === location.coLocationId 
              && inventory.isDefault
            )
          }
          dataLocation.push(item)
        }
      })
      return dataLocation
    },

    async getListLocation(roleUser) {
      try {
        const params = {
          limit: 1000,
          page: 1,
          sortBy: "name",
          sort: "ASC"
        }
        let listLocation = await LocationService.getListLocationDashboard(params);
        let listInventory = await this.getListInventory()
        if (listLocation.success && roleUser === "employee") {
          return this.inforLocation(listLocation.data, listInventory).filter(e => e.coLocationId === VueCookies.get('LID'))
        } else {
          return this.inforLocation(listLocation.data, listInventory);
        }
      } catch (error) {
        return []
      }
    },
  }
}